import { Schema } from '../schema/index.js';

export enum FSetupFetchActionType {
  Space,
  Furniture,
  FurnitureOptions,
  FCompositionSchema,
  Decoration,
}

export interface FSetupFetchSpacePayload {
  url: string;
  name: string;
}
export interface FSetupFetchFurniturePayload {
  url: string;
  name: string;
  furnitureType: string;
}

export interface FSetupFetchFurnituresPayload
  extends Array<{
    id: number;
    name: string;
    url: string;
  }> {}

export interface FSetupFetchFurnitureOptionsPayload {
  [id: number]: {
    name: string;
    id: number;
  };
}

export interface FSetupFetchFCompositionSchemaPayload {
  schema: Schema;
}

export interface FSetupFetchDecorationPayload {
  url: string;
  name: string;
  decorationType: string;
}
export interface FSetupFetchDecorationsPayload
  extends Array<{
    id: number;
    name: string;
    url: string;
  }> {}

export interface FSetupFetchFCompositionSchemasPayload
  extends Array<{
    id: number;
    schemaType: string;
    compositionType: string;
  }> {}

export type FSetupFetchActionReturnType = {
  [FSetupFetchActionType.Space]: FSetupFetchSpacePayload;
  [FSetupFetchActionType.Furniture]: FSetupFetchFurniturePayload;
  [FSetupFetchActionType.FurnitureOptions]: FSetupFetchFurnitureOptionsPayload;
  [FSetupFetchActionType.FCompositionSchema]: FSetupFetchFCompositionSchemaPayload;
  [FSetupFetchActionType.Decoration]: FSetupFetchDecorationPayload;
};

export type FSetupFetchActionInput = {
  [FSetupFetchActionType.Space]: number;
  [FSetupFetchActionType.Furniture]: number;
  [FSetupFetchActionType.FurnitureOptions]: number;
  [FSetupFetchActionType.FCompositionSchema]: number;
  [FSetupFetchActionType.Decoration]: number;
};

export interface FSetupFetchMethodFunction<
  TDefaultType extends FSetupFetchActionType = FSetupFetchActionType
> {
  <TType extends FSetupFetchActionType = TDefaultType>(
    type: TType,
    input: FSetupFetchActionInput[TType]
  ): Promise<FSetupFetchActionReturnType[TType]>;
}
